export const validationMessages = {
  es: {
    required: 'Campo requerido',
    title: 'El título es requerido',
    prompt: 'El prompt es requerido',
    invalidChars: 'Caracteres no permitidos',
  },
  en: {
    required: 'Required field',
    title: 'Title is required',
    prompt: 'Prompt is required',
    invalidChars: 'Invalid characters',
  },
};

export const getValidationMessage = (language: string, key: keyof typeof validationMessages['es']) => {
  return validationMessages[language as keyof typeof validationMessages]?.[key] || validationMessages.es[key];
};

// Mensajes de validación dinámicos por idioma
export const getValidationMessages = (language: string) => {
  const messages = {
    es: {
      titleRequired: "Por favor ingrese el título",
      exampleTextRequired: "Por favor ingrese el ejemplo de texto", 
      numberOfLinesRequired: "Por favor ingrese el número de líneas",
      minimumLines: "Debe ser al menos 1",
    },
    en: {
      titleRequired: "Please enter the title",
      exampleTextRequired: "Please enter the example text",
      numberOfLinesRequired: "Please enter the number of lines", 
      minimumLines: "Must be at least 1",
    },
  };

  return messages[language as keyof typeof messages] || messages.es;
};
